<template>
  <div ref="container" class="d-flex flex-column h-100 strategy-container text-center">
    <h3 class="strategy-title">
      <span class="line line-1">Building a Sustainable</span><br />
      <span class="line line-2"> Future Together </span>
    </h3>
  </div>
</template>

<script>
export default {
  name: 'TogetherText',
  data() {
    return {
      title: 'ESG Key Metrics',
      buttonText: 'VIEW MORE',
      observer: null,
      lastVisibleTimestamp: 0
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.$refs.container.classList.add('in-view');
            this.lastVisibleTimestamp = Date.now();
          } else {
            if (Date.now() - this.lastVisibleTimestamp > 1000) {
              this.$refs.container.classList.remove('in-view');
            }
          }
        });
      },
      {
        threshold: 0.2
      }
    );

    this.observer.observe(this.$refs.container);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped>
.strategy-title {
  font-weight: 600;
  font-size: 80px;
  line-height: 120%;
  letter-spacing: -2.5%;
  color: #111111;
}
.strategy-text {
  font-family: Pretendard;
  font-weight: 500;
  font-size: 22px;
  line-height: 140%;
  letter-spacing: 0%;
  color: #111111;
}
.strategy-btn {
  padding: 14px 24px;
  border: 1.2px solid #000000;
  border-radius: 60px;
  background: #ffffff;
  font-family: Red Hat Display;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0%;
}

@media (min-width: 1200px) {
  .strategy-title {
    font-size: calc(48px + (32 * ((100vw - 1200px) / (1920 - 1200))));
  }
  .strategy-text {
    font-size: calc(18px + (4 * ((100vw - 1200px) / (1920 - 1200))));
  }
}

@media (max-width: 1199px) {
  .strategy-title {
    font-size: calc(24px + (24 * ((100vw - 450px) / (1200 - 450))));
  }
  .strategy-text {
    font-size: calc(18px + (4 * ((100vw - 450px) / (1200 - 450))));
  }
}

@media (min-width: 1920px) {
  .strategy-title {
    font-size: 80px;
  }
  .strategy-text {
    font-size: 22px;
  }
}

.line {
  opacity: 0;
  transform: translateY(40px);
}
.strategy-container.in-view .line-1 {
  animation: fadeUp 1s ease forwards;
  animation-delay: 0s;
}
.strategy-container.in-view .line-2 {
  animation: fadeUp 1s ease forwards;
  animation-delay: 0.5s;
}
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
